import { Component, OnInit } from '@angular/core';
import {FormBuilder,Validators,FormGroup, FormControl} from '@angular/forms';
import {HttpRequestService} from './../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../_services/common.service';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute} from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-recive-announcement',
  templateUrl: './recive-announcement.component.html',
  styleUrls: ['./recive-announcement.component.scss']
})
export class ReciveAnnouncementComponent implements OnInit {
  announcementForm:FormGroup;
  announcementFormSubmitStatus:boolean = false;
  pageDetails:any;
  constructor( private formBilder: FormBuilder,
		private httpServices:HttpRequestService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private cService: CommonService,
    public router: Router) {
      this.cService.activelang.subscribe((lang) => {

        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(lang);
  
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang);
      });
    }

  ngOnInit() {
    this.announcementForm = this.formBilder.group({
      'name':['',Validators.required],
      'email':['',[Validators.required, Validators.email]],
    });

      

  }
  announcementFormSubmitAction() {
    this.announcementFormSubmitStatus = true;
    if (this.announcementForm.valid) {
      let formData = this.announcementForm.value;
      this.httpServices.setModule('action').post('announcement_store',formData).subscribe((response) => {

        if (response.status=='success') {
          this.translate.get([
            'THANK_YOU',
            'MESSAGE_SEND_SUCCESSFULL'
          ]).subscribe((tData)=>{
            this.resetAnnouncementForm();
            Swal.fire(tData['THANK_YOU'], tData['MESSAGE_SEND_SUCCESSFULL'], 'success');
          })
        }
        if (response.status=='error') {
          this.toastr.error( response.data,'Error:');
        }
      }, (error) => {
        console.log(error);
      });
    }
  }
  resetAnnouncementForm() {
    this.announcementFormSubmitStatus = false;
    this.announcementForm.reset();
  }

}
